import { LANGUAGE_ENUMS } from '../../../constants/staticPageConstants';
import { DotComMobileNavbarSA } from '../DotComHeaderSA';
import { TDropdownList } from '../DynamicHeader/Dropdown/DropdownComponent';
import {
  CONTACT_US_PAGE,
  HEADER_LABELS,
} from '../DynamicHeader/Dropdown/DropdownData';

interface IProps {
  language: LANGUAGE_ENUMS;
  LangSwitchLink?: TDropdownList;
  domain: number;
}

const MobileNavBar = ({
  language = LANGUAGE_ENUMS.English,
  LangSwitchLink,
  domain,
}: IProps): JSX.Element => {
  const header_labels = HEADER_LABELS[language as keyof typeof HEADER_LABELS];

  const direction = language === LANGUAGE_ENUMS.Arabic ? 'rtl' : 'ltr';

  return (
    <>
      <DotComMobileNavbarSA
        direction={direction}
        domain={domain}
        language={language}
        header_labels={header_labels}
        LangSwitchLink={LangSwitchLink}
        contact_us_page={CONTACT_US_PAGE}
      />
    </>
  );
};

export { MobileNavBar };
